// extracted by mini-css-extract-plugin
export default {"button":"add-button_button__BoESz","text":"add-button_text__JfsJ3","icon":"add-button_icon__Rzv6K"};